<div *ngFor="let record of vibrationRecords; index as j;"
    class="border p-2 m-2 text-start rounded-1 mb-2 text-size  record" (click)="onRecordClick(record, j)"
    [ngClass]="{'active': selectedRecordIndex === j}">
    <div class="cursor font-size-detail">
        <div class="p-1 rounded-1">
            <div>
                <div class="row mt-2 ">
                    <div class="col-12 d-flex align-items-center">
                        <img src="./icon/calendar.svg" />
                        <div class=" ms-2">
                            <span>{{record?.recordMetadata.timestamp | date: 'dd/MM/yyyy'}}</span>
                            <span class="ms-1">{{record?.recordMetadata.timestamp | date: 'HH:mm:ss'}}</span>
                        </div>
                    </div>
                </div>
            </div>


            <div class="mt-2">
                <div class="row d-flex align-items-left mt-2 text-muted">
                    <div class="col-6">
                        PPV Max (mm/s)
                    </div>
                    <div class="col-6">
                        VS (mm/s)
                    </div>
                </div>

                <div class="row d-flex align-items-left">
                    <div class="col-6">
                        {{ getPicPPVFirstThree(record) | number : '1.2-2' }}
                    </div>
                    <div class="col-6">
                        {{record?.recordMetadata.vecSomme | number : '1.2-2'}}
                    </div>
                </div>
            </div>

            <div class="mt-2">
                <div class="text-muted"> {{'RECORD.AIR_OVERPRESSURE' |
                    translate}}</div>
                <div class="row">
                    <div class="col-6">
                        Pa: {{ record?.recordMetadata.overpressure | number: '1.2-2' }}
                    </div>
                    <div class="col-6">
                        dB(L): {{
                        pascalToDecibel(record?.recordMetadata.overpressure) | number: '1.2-2' }}
                    </div>
                </div>

            </div>
        </div>
        <hr class="mt-2">
        <div>
            <div class="row mt-2" [ngClass]="{'opacity-50': !record.eventId}">
                <div class="col-12 d-flex align-items-center">
                    <img src="./icon/blastMenu.svg" />
                    <span class="ms-2 "> {{getEventName(record.eventId) }}</span>
                    <span *ngIf="!record.eventId" class="text-muted"> {{'RECORD.UNASSIGNED' |
                        translate}}</span>

                </div>
            </div>
        </div>

        <div>
            <div class="row mt-2" [ngClass]="{'opacity-50': !record.controlPointId}">
                <div class="col-12 d-flex align-items-center">
                    <img src="./icon/control-point-black.svg" />
                    <span *ngIf="record.controlPointId" class="ms-2 "> {{getControlPointName(record.controlPointId)
                        }}</span>
                    <span *ngIf="!record.controlPointId" class="ms-2 text-muted"> {{'RECORD.UNASSIGNED' |
                        translate}}</span>
                </div>
            </div>
        </div>

        <div>
            <div class="row mt-2">
                <div class="col-12 d-flex align-items-center">
                    <img src="./icon/device.svg" />
                    <span class="ms-2 "> {{record.recordMetadata.seismographSerialNumber }}</span><br>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-2 text-decoration-underline cursor" (click)="onSeeRecordClick(record.id)" style="font-size: 1rem;">
        {{'MESSAGE_INFO.SEE_RECCORD' | translate}}
    </div>
</div>